import { useTranslation } from "react-i18next";
import { useSession } from "../auth/SessionProvider";
import GameScreen from "../game/GameScreen";
import Login from "./Login";

export default function ChildHome() {
  const { t } = useTranslation();
  const { user } = useSession();

  // On ne sait pas encore qui est connecté : on n'affiche ni le jeu ni la
  // connexion, pour éviter que l'écran ne saute sous les yeux du jeune.
  if (user === undefined) {
    return (
      <main className="screen screen--centered">
        <p className="card__text card__text--muted">{t("common.loading")}</p>
      </main>
    );
  }

  return user === null ? <Login /> : <GameScreen />;
}
